import React from 'react';
export function Hero() {
  return <section className="bg-bg py-16 md:py-24 overflow-hidden" data-id="element-61">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-12" data-id="element-62">
        <div className="w-full md:w-[55%] space-y-8" data-id="element-63">
          <div className="inline-flex items-center gap-2 bg-accent/20 text-secondary px-4 py-1.5 rounded-full text-sm font-bold" data-id="element-64">
            <span data-id="element-65">🌙</span>
            NUEVO — Método basado en ciencia
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-text leading-tight" data-id="element-66">
            ¿Y si esta noche
            <br data-id="element-67" />
            pudieras dormir
            <br data-id="element-68" />
            de verdad por
            <br data-id="element-69" />
            primera vez?
          </h1>

          <p className="text-gray text-lg md:text-xl leading-relaxed max-w-lg" data-id="element-70">
            El Código del Sueño Profundo es el método de 14 días que regula tu
            ritmo circadiano, baja el cortisol nocturno y te devuelve el sueño
            profundo que mereces — sin pastillas, sin apps y sin contar ovejas.
          </p>

          <a href="#pricing" className="inline-block w-full sm:w-auto text-center bg-primary text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-primary/90 transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-71">
            QUIERO DORMIR MEJOR ESTA NOCHE &rarr;
          </a>

          <div className="flex flex-wrap items-center gap-6 text-sm font-bold text-text/80 pt-2" data-id="element-72">
            <div className="flex items-center gap-2" data-id="element-73">
              <span className="text-lg" data-id="element-74">🌙</span> Sin pastillas
            </div>
            <div className="flex items-center gap-2" data-id="element-75">
              <span className="text-lg" data-id="element-76">📥</span> Descarga inmediata
            </div>
            <div className="flex items-center gap-2" data-id="element-77">
              <span className="text-lg" data-id="element-78">⭐</span> Resultados en 14 días
            </div>
          </div>
        </div>

        <div className="w-full md:w-[45%] relative" data-id="element-79">
          <div className="absolute inset-0 bg-accent/20 rounded-full blur-3xl -z-10 transform translate-x-8 translate-y-8" data-id="element-80"></div>
          <img src="https://cdn.magicpatterns.com/uploads/e7VBU68xtx9tEAucvqe28P/Portada_Codigo_del_Sueno_Profundo.png" alt="El Código del Sueño Profundo" className="w-full aspect-square object-cover rounded-2xl shadow-2xl" data-id="element-81" />
        </div>
      </div>
    </section>;
}